import {
  toLakh,
  sumThis,
  numberWithCommas,
  toCurrency,
  sumOf,
  countOf,
  sumAndCountOf,
  showSum,
  showCount,
  showSumAndCount,
  percentChange,
  showBlank,
  changeClassTo,
  mobileNumber,
  panCardNumber,
  validEmail,
  adharNumber,
  allDirectQueries
} from "../../commonFunctions";
import { controls } from "../../controls";


const accstatement = {
  label: "A/c Statement",
  pageLabel: "A/c Statement",
  starting: true,
  url: "accstatement",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [

    ...controls.displayText({ star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ isRequired: true, width: "col-sm-2" }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-2" }),
    ...controls.checkBox({ name: "isCustomer", label: "Customer", width: "col-sm-2" }),
    ...controls.displayText({ label: "CIN", width: "col-sm-2" }),
    ...controls.showData({
      data: "cin", name: "cin", width: "col-sm-2",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: 'readonly'
        }
      ],
    }),
    ...controls.displayText({ star: true, label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ isRequired: true, star: true, width: "col-sm-2" }),
    ...controls.showData({ data: "product_code_display", name: "product_code_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-2" }),
    ...controls.displayText({ label: "Balance", width: "col-sm-2" }),
    ...controls.showData({
      data: "balance", name: "balance", width: "col-sm-2",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: 'readonly'
        }
      ],
    }),
    ...controls.displayText({ star: true, label: "Account Number", width: "col-sm-2" }),
    ...controls.AccountNumber({ isRequired: true, width: "col-sm-4" }),
    ...controls.showData({ data: "account_number_display", name: "account_number_display", width: "col-sm-4" }),
    ...controls.displayText({ width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-2", label: "Address" }),
    ...controls.showData({
      data: "address_1", name: "address_1", width: "col-sm-4",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: 'readonly'
        }
      ],
    }),
    ...controls.displayText({ width: "col-sm-2", label: "gstn" }),
    ...controls.showData({
      data: "gstn", name: "gstn", width: "col-sm-4",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: ''
        }
      ],
    }),
    ...controls.displayText({ width: "col-sm-2", star: true, label: "From-To Date" }),
    ...controls.datePicker({
      isRequired: true, width: "col-sm-2",
      defaultValue: "open_date",
      // displaytype:"date",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: 'readonly'
        }
      ],
      name: "from_date",

    }),
    ...controls.displayText({ width: "col-sm-2", label: "-" }),
    ...controls.datePicker({
      isRequired: true, width: "col-sm-2",
      name: "to_date",
      defaultValue: "sessiondate",
    }),
    ...controls.displayText({ width: "col-sm-2", label: "Open By" }),
    ...controls.showData({
      data: "open_by", name: "open_by", width: "col-sm-2",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: 'readonly'
        }
      ],
    }),
    ...controls.displayText({ width: "col-sm-2", label: "Opening Date" }),
    ...controls.showData({
      data: "open_date", displaytype: "date", name: "open_date_1", width: "col-sm-2",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: 'readonly'
        }
      ],
    }),
    ...controls.displayText({ width: "col-sm-2", label: "Expiry Date" }),
    ...controls.showData({
      data: "expiry_date", displaytype: "date", name: "expiry_date", width: "col-sm-2",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: 'readonly'
        }
      ],
    }),
    ...controls.displayText({ width: "col-sm-2", label: "Period" }),
    ...controls.showData({
      data: "period_months", name: "period_months", width: "col-sm-2",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: 'readonly'
        }
      ],
    }),
    ...controls.displayText({ width: "col-sm-2", label: "Intrest" }),
    ...controls.showData({
      data: "intrest_rate", name: "intrest_rate", width: "col-sm-2",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: 'readonly'
        }
      ],
    }),
    ...controls.displayText({ width: "col-sm-2", label: "FD Amount" }),
    ...controls.showData({
      data: "fd_amount", name: "fd_amount", width: "col-sm-2",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: 'readonly'
        }
      ],
    }),
    ...controls.displayText({ width: "col-sm-2", label: "Maturity Amount" }),
    ...controls.showData({
      data: "maturity_amount", name: "maturity_amount", width: "col-sm-2",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: 'readonly'
        }
      ],
    }),
    ...controls.displayText({ width: "col-sm-2", label: "Mobile" }),
    ...controls.showData({
      data: "mobile", name: "mobile", width: "col-sm-2",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: 'readonly'
        }
      ],
    }),
    ...controls.displayText({ width: "col-sm-2", label: "PAN" }),
    ...controls.showData({
      data: "pan_no", name: "pan_no", width: "col-sm-2",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: 'readonly'
        }
      ],
    }),
    ...controls.displayText({ width: "col-sm-2", label: "AAdharID" }),
    ...controls.showData({
      data: "aadhar_id", name: "aadhar_id", width: "col-sm-2",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: 'readonly'
        }
      ],
    }),
    ...controls.displayText({ width: "col-sm-2", label: "Lien Information" }),
    ...controls.showData({
      data: "lien_info", name: "lien_info", width: "col-sm-2",
      parents: [
        {
          name: "account_number",
          match: "exist",
          show: 'readonly'
        }
      ],
    }),

    //     {
    //       inputType: "table",
    //       tableTitle: "Account Table",
    //       tab: "accstatement",
    //       tableHeaders: [
    //         { label: "Date", value: "Date"  },
    //         { label: "Particulars", value: "Particulars" },
    //         { label: "Chq-No", value: "Chq-No" },
    //         { label: "Type", value: "Type" },
    //         { label: "Batch No", value: "Batch No" },
    //         { label: "Int Flag", value: "Int Flag" },
    //         { label: "Credit", value: "Credit" },
    //         { label: "Debit", value: "Debit" },{ label: "Balance", value: "Balance" }
    //       ],
    //       widths: {
    //         parent: "col-sm-12",
    //         children: "col-sm-12"
    //       },
    //       name: "account_statement"
    //  },

  ]
}

export default accstatement;